@if (phoneNumberItems.length > 0) {
  <ul>
    @for (phoneNumber of phoneNumberItems; track phoneNumber) {
      <li>
        <div class="phone-number-list-item-wrapper">
          <div class="account-phone-number-name">
            {{ phoneNumber.phoneNumber | formatPhoneNumbers }}
            @if (!phoneNumber.isActive) {
              <span class="inactive-label">(Inactive)</span>
            }
          </div>
          <div class="account-phone-number-name">{{ phoneNumber.displayName }}</div>
          <div class="phone-number-details">
            <span #buttonWrapper>
              <button
                type="button"
                title="Phone Number Details"
                mat-icon-button
                (click)="onDetailsClick(phoneNumber, buttonWrapper)"
                >
                <mat-icon>{{
                  selectedPhoneNumber === phoneNumber.phoneNumber ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                }}</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" title="Remove Phone Number" mat-icon-button (click)="onRemoveClick(phoneNumber)">
            <mat-icon class="remove-btn">close</mat-icon>
          </button>
        </div>
      </li>
    }
  </ul>
} @else {
  <span class="no-phone-numbers-label">No phone numbers added</span>
}
